// import React from 'react'
import { components, defaults } from './components/schema-forms/components/detailsPageComponents'
import ReactTable from 'react-table-6'
import Dropdown from './components/common/dropdown'

components.Dropdown = Dropdown
components.Table = ReactTable

defaults.headerButton.submit = {className: 'btn', title: 'Submit'}
defaults.headerButton.cancel = {className: 'btn btn-secondary'}
defaults.headerButton.all = {style: {marginRight: '1em'}}
defaults.wizard.footerButtons = [
    ({ prevPage, currentPage }) => (<button className='btn btn-secondary' disabled={currentPage === 0} onClick={prevPage}>Back</button>),
    ({ nextPage, currentPage, maxClickableIdx }) => (<button className='btn' disabled={currentPage === maxClickableIdx} onClick={nextPage}>Next</button>)
]